"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _woying = require("@/api/woying");
var _toolsValidate = require("@/utils/toolsValidate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WoyingRewardList',
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) return callback(new Error('请输入手机号'));
      if (!_toolsValidate.PhoneReg.test(value)) return callback(new Error('手机号格式不正确'));
      callback();
    };
    return {
      listLoading: false,
      addLoading: false,
      timeVal: [],
      tableFrom: {
        startTime: '',
        endTime: '',
        phone: '',
        uid: ''
      },
      tableData: [],
      dialogVisible: false,
      addForm: {
        phone: ''
      },
      addRules: {
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _woying.getUserRewardStatsApi)(this.tableFrom).then(function (res) {
        _this.tableData = Array.isArray(res) ? res : res.list || res.data || [];
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    searchList: function searchList() {
      this.getList();
    },
    handleReset: function handleReset() {
      this.timeVal = [];
      this.tableFrom = {
        startTime: '',
        endTime: '',
        phone: '',
        uid: ''
      };
      this.getList();
    },
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e || [];
      this.tableFrom.startTime = this.timeVal.length ? this.timeVal[0] : '';
      this.tableFrom.endTime = this.timeVal.length ? this.timeVal[1] : '';
      this.searchList();
    },
    openAddDialog: function openAddDialog() {
      this.dialogVisible = true;
    },
    closeDialog: function closeDialog() {
      var _this2 = this;
      this.dialogVisible = false;
      this.addLoading = false;
      this.$nextTick(function () {
        if (_this2.$refs.addFormRef) _this2.$refs.addFormRef.resetFields();
      });
    },
    submitAdd: function submitAdd() {
      var _this3 = this;
      this.$refs.addFormRef.validate(function (valid) {
        if (!valid) return;
        _this3.addLoading = true;
        (0, _woying.addUserApi)(_this3.addForm).then(function () {
          _this3.$message.success('添加成功');
          _this3.closeDialog();
          _this3.getList();
        }).finally(function () {
          _this3.addLoading = false;
        });
      });
    },
    handleImportExcel: function handleImportExcel(option) {
      var _this4 = this;
      var file = option && option.file;
      if (!file) return;
      var isExcel = /\.(xlsx|xls)$/i.test(file.name);
      if (!isExcel) {
        this.$message.warning('请上传 xlsx/xls 文件');
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      (0, _woying.importUserApi)(formData).then(function () {
        _this4.$message.success('导入成功');
        _this4.getList();
        if (option.onSuccess) option.onSuccess();
      }).catch(function () {
        if (option.onError) option.onError();
      });
    }
  }
};